// deps
import React, { ReactElement, useMemo } from "react";

// components
import PaymentGroupTitle from "../components/Title";
import PaymentGroupContainer from "../components/Container";
import Wallet from "@payment-ui/components/payment-method/wallet";

// helpers
import { isEmpty } from "@swiggy-private/payment-core";
import {
    getPaymentMethods,
    isPaymentMethodSelected,
    generatePaymentMethodId,
    getPaymentGroupDisplayName,
    isPaymentGroupEnabled,
    getPaymentGroupDisableMessage,
    getPaymentGroupIconUrl,
} from "@payment-ui/helpers/Payment";

// interfaces
import { IWalletPaymentGroup } from "@payment-ui/interfaces/Wallet";

// test-ids
import { PAYMENT_GROUP_TEST_IDS } from "@swiggy-private/payment-test-ids";
import styles from "../PaymentGroup.v4.scss";

export default function WalletPaymentGroup(props: IWalletPaymentGroup): ReactElement | null {
    const { isFrictionPage } = props;
    const paymentMethods = useMemo(() => getPaymentMethods(props), [props]);
    const isGroupEnabled = useMemo(() => isPaymentGroupEnabled(props.paymentData), [props.paymentData]);

    if (isEmpty(paymentMethods)) {
        return null;
    }
    return (
        <PaymentGroupContainer isFrictionPage={isFrictionPage}>
            {!props.hideGroupTitle && (
                <PaymentGroupTitle
                    title={getPaymentGroupDisplayName(props.paymentData)}
                    disableMessage={getPaymentGroupDisableMessage(props.paymentData)}
                    data-testid={PAYMENT_GROUP_TEST_IDS.TITLE.WALLET}
                    groupIcon={getPaymentGroupIconUrl(props.paymentData)}
                />
            )}
            <div className={styles.paymentGroupContainer}>
                {paymentMethods.map(paymentMethod => {
                    const id = generatePaymentMethodId(paymentMethod);
                    return (
                        <Wallet
                            key={paymentMethod.displayName}
                            id={id}
                            methodData={paymentMethod}
                            paymentActions={props.paymentActions}
                            user={props.user}
                            isPaymentGroupEnabled={isGroupEnabled}
                            paymentAmount={paymentMethod.payableAmount ?? props.paymentAmount}
                            selected={isPaymentMethodSelected(props.selectedPaymentId, id)}
                        />
                    );
                })}
            </div>
        </PaymentGroupContainer>
    );
}
